import './text-flag.scss'

export const TextFlag = ({
  index,
  textContent,
  backgroundColor,
  textColor,
}: any) => {
  const styles = {
    color: textColor,
    backgroundColor,
  }

  return (
    <span
      className={`text-flag${index === 0 ? ' first-flag' : ' second-flag'}`}
      style={styles}
    >
      {textContent}
    </span>
  )
}
